import { Mol } from '@moleculeone/types';
import React from 'react';

import { styled } from '../../../../../../stitches.config';
import { Icon } from '../../../../../text/Icon/Icon';
import { Button } from '../../../../Button/Button';
import { CompoundPreview } from './CompoundPreview';

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  margin: '$5 0',
});
const SubstratePlus = styled('div', {
  fontSize: '$5',
  margin: '0 $2',
  color: '$slate8',
  userSelect: 'none',
});
const ReactionArrow = styled(Icon, {
  fontSize: '$5',
  margin: '0 $2',
  color: '$slate8',
  userSelect: 'none',
});
const Info = styled('p', {
  display: 'flex',
  alignItems: 'center',
  gap: '$3',
  fontSize: '$2',
  fontWeight: 300,
  color: '$slate10',
});

type ReactionPreviewProps = {
  mols: {
    substrates: Mol[];
    product: Mol;
  };
  onPickAtom: any;
  onPickBond: any;
  replaceReaction: any;
  onSelected: () => void;
};
export const ReactionPreview = ({
  mols,
  onPickAtom,
  onPickBond,
  replaceReaction,
  onSelected,
}: ReactionPreviewProps) => {
  return (
    <>
      <Container>
        {mols.substrates.map((substrateMol, idx) => (
          <React.Fragment key={idx}>
            {idx !== 0 && <SubstratePlus>+</SubstratePlus>}
            <CompoundPreview
              mol={substrateMol}
              onMouseDown={(_: any, molEvent: any) => {
                if (molEvent.atom) {
                  onPickAtom(substrateMol, molEvent.idx);
                  onSelected();
                } else if (molEvent.bond) {
                  onPickBond(substrateMol, molEvent.idx);
                  onSelected();
                }
              }}
              renderDelay={idx * 30}
            />
          </React.Fragment>
        ))}
        {mols.product && (
          <>
            <ReactionArrow icon="east" />
            <CompoundPreview
              mol={mols.product}
              onMouseDown={(_: any, molEvent: any) => {
                if (molEvent.atom) {
                  onPickAtom(mols.product, molEvent.idx);
                  onSelected();
                } else if (molEvent.bond) {
                  onPickBond(mols.product, molEvent.idx);
                  onSelected();
                }
              }}
              renderDelay={60}
            />
          </>
        )}
      </Container>
      <Info>
        <Icon icon="info" /> Select atom or bond to insert by{' '}
        {mols.substrates.length === 2 && mols.product && (
          <>
            or{' '}
            <Button
              text="Replace whole reaction"
              weight="solid"
              theme="purple"
              size="small"
              onClick={() => {
                replaceReaction([...mols.substrates, mols.product]);
                onSelected();
              }}
            />
          </>
        )}
      </Info>
    </>
  );
};
